import { render, staticRenderFns } from "./TotalrecdetailReport.vue?vue&type=template&id=30c296b4"
import script from "./TotalrecdetailReport.vue?vue&type=script&lang=js"
export * from "./TotalrecdetailReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports